import * as React from "react";
import {prepareUploadJobImage} from "../service/ImageService";
import ImageUpload from "./ImageUpload";


export default function JobImageUpload(props) {
    const {job, images, setImages} = props;

    const prepareUpload = (fileName, fileType) => {
        return prepareUploadJobImage(fileName, fileType, job.cos_job_id);
    };

    return (
        <ImageUpload
            images={images}
            setImages={setImages}
            prepareUpload={prepareUpload}
        />
    )
}
